import { Spinner } from "@/components/ui/spinner";

import { cn } from "@/lib/utils";

import {
    COVER_SIZE_CLASS,
    PLACEHOLDER_REST_CLASS,
    STRIP_HEIGHT_CLASS,
} from "./imageStripLayout";

export function PendingUploadTile({ isCover }: { isCover: boolean }) {
    return (
        <div
            className={cn(
                "flex shrink-0 snap-start items-center justify-center rounded-md bg-zinc-100",
                STRIP_HEIGHT_CLASS,
                isCover ? COVER_SIZE_CLASS : PLACEHOLDER_REST_CLASS,
            )}
        >
            <Spinner className="size-5" />
        </div>
    );
}
